import { focusBaseStyles as n } from "../themes/focus.js";
import "react";
const N = (r) => {
  switch (r) {
    case "24":
      return 14;
    case "32":
    case "40":
      return 16;
    case "48":
      return 18;
    case "56":
      return 20;
    default:
      return 16;
  }
}, u = ({
  endIcon: r,
  gap: e,
  loading: a,
  startIcon: p,
  theme: i
}) => ({
  "& .Thr-Button-Text": {
    opacity: a ? "0" : "1",
    transition: "opacity 200ms ease-in-out",
    display: "flex",
    alignItems: "center",
    ...p && r && {
      marginRight: i.spacing(0),
      marginLeft: i.spacing(0)
    },
    ...p && !r && {
      marginRight: i.spacing(e)
    },
    ...r && !p && {
      marginLeft: i.spacing(e)
    }
  }
}), P = ({
  appearance: r = "solid",
  disabled: e,
  endIcon: a,
  href: p,
  intent: i = "prominent",
  loading: o,
  startIcon: c,
  theme: t,
  size: x
}) => {
  const l = r === "outline", f = {
    prominent: {
      solid: t.palette["base/white/white"],
      outline: e ? t.palette["text/interactive/disabled"] : t.palette["text/status-prominent"],
      ghost: e ? t.palette["text/interactive/disabled"] : t.palette["text/status-prominent"]
    },
    neutral: {
      solid: t.palette["base/white/white"],
      outline: e ? t.palette["text/interactive/disabled"] : t.palette["text/contrast-max"],
      ghost: e ? t.palette["text/interactive/disabled"] : t.palette["text/contrast-max"]
    },
    negative: {
      solid: t.palette["base/white/white"],
      outline: e ? t.palette["text/interactive/disabled"] : t.palette["text/status-negative"],
      ghost: e ? t.palette["text/interactive/disabled"] : t.palette["text/status-negative"]
    }
  }, m = {
    alignItems: "center",
    alignSelf: "auto",
    borderRadius: t.shape.borderRadius * 2,
    // 8px
    boxSizing: "border-box",
    color: t.palette["base/white/white"],
    display: p ? "inline-flex" : "flex",
    fontFamily: t.typography.sans,
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontSize: t.spacing(2.5),
    // 2.0rem (20px)
    fontStyle: "normal",
    fontWeight: 600,
    gap: t.spacing(1),
    // 8px / 0.8rem
    justifyContent: "center",
    letterSpacing: "normal",
    lineHeight: t.spacing(3.5),
    // 2.8rem (28px)
    minHeight: "56px",
    minWidth: "auto",
    padding: l ? "13px 19px" : "14px 20px",
    textTransform: "none",
    ":active": {
      transform: "scale(0.98)"
    },
    transition: "color 300ms ease-in-out, background-color 300ms ease-in-out, border-color 300ms ease-in-out, transform 200ms ease-in-out",
    "& .MuiButton-startIcon, .MuiButton-endIcon": {
      "& .MuiSvgIcon-root": {
        color: f[i][r] || "inherit",
        transition: "color 200ms ease-in-out"
      },
      margin: 0,
      opacity: o ? "0" : "1",
      transition: "opacity 200ms ease-in-out",
      "& *:nth-of-type(1)": {
        fontSize: `${N(x)}px`
      }
    },
    ...u({ theme: t, startIcon: c, endIcon: a, gap: 1, loading: o })
  }, g = {
    borderRadius: t.shape.borderRadius * 1.5,
    // 6px
    fontSize: t.spacing(2),
    // 16px / 1.6rem
    gap: t.spacing(1),
    // 8px / 0.8rem
    lineHeight: t.spacing(3),
    // 24px / 2.4rem
    minHeight: "48px",
    padding: l ? "11px 15px" : "12px 16px",
    ":active": {
      transform: "scale(0.98)"
    },
    ...u({ theme: t, startIcon: c, endIcon: a, gap: 1, loading: o })
  }, v = {
    ...g,
    fontSize: t.spacing(1.75),
    // 1.4rem / 14px
    gap: t.spacing(0.75),
    minHeight: "40px",
    padding: l ? "7px 13px" : "8px 14px",
    ":active": {
      transform: "scale(0.98)"
    },
    ...u({ theme: t, startIcon: c, endIcon: a, gap: 0.75, loading: o })
  }, k = {
    ...v,
    borderRadius: t.shape.borderRadius,
    // 4px
    fontSize: t.spacing(1.75),
    // 1.4rem
    gap: t.spacing(0.5),
    // 4px / 0.4rem
    minHeight: "32px",
    padding: l ? "3px 7px" : "4px 8px",
    ":active": {
      transform: "scale(0.98)"
    },
    ...u({ theme: t, startIcon: c, endIcon: a, gap: 0.5, loading: o })
  }, y = {
    ...k,
    fontSize: t.spacing(1.5),
    lineHeight: t.spacing(2),
    minHeight: "24px",
    padding: l ? "3px 5px" : "4px 6px",
    ":active": {
      transform: "scale(0.98)"
    },
    ...u({ theme: t, startIcon: c, endIcon: a, gap: 0.25, loading: o })
  }, d = {
    ...!o && {
      "&[aria-disabled=true]": {
        backgroundColor: t.palette["component/button/disabled/background-filled"],
        cursor: "not-allowed",
        "& .Thr-Button-Text": {
          color: t.palette["component/button/disabled/text"]
        }
      }
    }
  }, C = {
    backgroundColor: o ? t.palette["component/button/neutral/background-filled-interacted"] : t.palette["component/button/neutral/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/neutral/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: t.palette["component/button/neutral/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/neutral/background-filled-interacted"],
      ...n
    },
    ...d
  }, S = {
    backgroundColor: o ? t.palette["component/button/prominent/background-filled-interacted"] : t.palette["component/button/prominent/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/prominent/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: t.palette["component/button/prominent/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/prominent/background-filled-interacted"],
      ...n
    },
    ...d
  }, $ = {
    backgroundColor: o ? t.palette["component/button/negative/background-filled-interacted"] : t.palette["component/button/negative/background-filled"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/negative/background-filled-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: t.palette["component/button/negative/background-filled"]
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/negative/background-filled-interacted"],
      ...n
    },
    ...d
  }, s = {
    ...!o && {
      "&[aria-disabled=true]": {
        border: `solid 1px ${t.palette["graphic/interactive/disabled/high"]}`,
        cursor: "not-allowed",
        "& .Thr-Button-Text": {
          color: t.palette["text/interactive/disabled"]
        }
      },
      ...e && {
        border: `solid 1px ${t.palette["graphic/interactive/disabled/high"]}`
      }
    }
  }, w = {
    backgroundColor: o ? t.palette["component/button/neutral/background-empty-interacted"] : "transparent",
    border: `solid 1px ${o ? t.palette["component/button/neutral/border-interacted"] : t.palette["component/button/neutral/border-resting"]}`,
    color: t.palette["text/contrast-max"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${t.palette["component/button/neutral/border-interacted"]}`,
        backgroundColor: t.palette["component/button/neutral/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/neutral/background-empty-interacted"] : "transparent",
        border: `solid 1px ${o ? t.palette["component/button/neutral/border-interacted"] : t.palette["component/button/neutral/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${t.palette["component/button/neutral/border-interacted"]}`,
      backgroundColor: t.palette["component/button/neutral/background-empty-interacted"],
      ...n
    },
    ...s
  }, z = {
    backgroundColor: o ? t.palette["component/button/negative/background-empty-interacted"] : "transparent",
    border: `solid 1px ${t.palette["component/button/negative/border-resting"]}`,
    color: t.palette["text/status-negative"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${t.palette["component/button/negative/border-interacted"]}`,
        backgroundColor: t.palette["component/button/negative/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/negative/background-empty-interacted"] : "transparent",
        border: `solid 1px ${t.palette["component/button/negative/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${t.palette["component/button/negative/border-interacted"]}`,
      backgroundColor: t.palette["component/button/negative/background-empty-interacted"],
      ...n
    },
    ...s
  }, B = {
    backgroundColor: o ? t.palette["component/button/prominent/background-empty-interacted"] : "transparent",
    border: `solid 1px ${t.palette["component/button/prominent/border-resting"]}`,
    color: t.palette["text/status-prominent"],
    "@media (hover: hover)": {
      ":hover": {
        border: `solid 1px ${t.palette["component/button/prominent/border-interacted"]}`,
        backgroundColor: t.palette["component/button/prominent/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/prominent/background-empty-interacted"] : "transparent",
        border: `solid 1px ${t.palette["component/button/prominent/border-resting"]}`
      }
    },
    ":focus-visible": {
      border: `solid 1px ${t.palette["component/button/prominent/border-interacted"]}`,
      backgroundColor: t.palette["component/button/prominent/background-empty-interacted"],
      ...n
    },
    ...s
  }, b = {
    ...!o && {
      "&[aria-disabled=true]": {
        // color: theme.palette["text/interactive/disabled"],
        cursor: "not-allowed",
        ".Thr-Button-Text": {
          color: t.palette["text/interactive/disabled"]
        }
      }
    }
  }, T = {
    backgroundColor: o ? t.palette["component/button/neutral/background-empty-interacted"] : "transparent",
    color: t.palette["text/contrast-max"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/neutral/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/neutral/background-empty-interacted"] : "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/neutral/background-empty-interacted"],
      ...n
    },
    ...b
  }, H = {
    backgroundColor: o ? t.palette["component/button/negative/background-empty-interacted"] : "transparent",
    color: t.palette["text/status-negative"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/negative/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/negative/background-empty-interacted"] : "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/negative/background-empty-interacted"],
      ...n
    },
    ...b
  }, R = {
    backgroundColor: o ? t.palette["component/button/prominent/background-empty-interacted"] : "transparent",
    color: t.palette["text/status-prominent"],
    "@media (hover: hover)": {
      ":hover": {
        backgroundColor: t.palette["component/button/prominent/background-empty-interacted"]
      }
    },
    "@media (hover: none)": {
      ":hover": {
        backgroundColor: o ? t.palette["component/button/prominent/background-empty-interacted"] : "transparent"
      }
    },
    ":focus-visible": {
      backgroundColor: t.palette["component/button/prominent/background-empty-interacted"],
      ...n
    },
    ...b
  };
  return {
    baseStyles: m,
    ghostNegativeStates: H,
    ghostNeutralStates: T,
    ghostProminentStates: R,
    outlineNegativeStates: z,
    outlineNeutralStates: w,
    outlineProminentStates: B,
    size24: y,
    size32: k,
    size40: v,
    size48: g,
    solidNegativeStates: $,
    solidNeutralStates: C,
    solidProminentStates: S
  };
};
export {
  P as default,
  N as getButtonIconSize
};
//# sourceMappingURL=Button.styles.js.map
